/*
 * Identity marker for a comparison row — shared by the comparison bars, the
 * diverging bars and the radar legend.
 *
 *  - team  (crops: the members' face crops) → a small overlapped cluster of
 *           their avatars, so a team reads as its players, not just a color.
 *  - player (crop: one face crop)           → a single avatar.
 *  - fallback (neither)                     → a filled identity dot.
 */

import type React from 'react';

export const EntityAvatar: React.FC<{
  name: string;
  color: string;
  crop?: string;
  crops?: string[];
}> = ({ name, color, crop, crops }) => {
  if (crops && crops.length > 0) {
    return (
      <span className="id-cluster">
        {crops.map((c, i) => (
          <span
            key={i}
            className="cmp-avatar id-cluster-avatar"
            style={{ boxShadow: `0 0 0 2.5px ${color}` }}
          >
            <img src={c} alt={name} />
          </span>
        ))}
      </span>
    );
  }
  if (crop) {
    return (
      <span className="cmp-avatar" style={{ borderColor: color }}>
        <img src={crop} alt={name} />
      </span>
    );
  }
  return (
    <span
      className="cmp-dot"
      style={{ background: color }}
      aria-hidden="true"
    />
  );
};
